import React from "react";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";
import NewBadge from "../components/NewBadge";
import { APP_INFO } from "../components/AppInfo";
import { useProgress } from "../utils/progress";

// Labels are retained from the first uploaded touchproject.
const courses = [
  {
    id: "eshleluud",
    to: "/eshleluud",
    icon: "order",
    title: "Эшлэлүүдийг зөв дараалалд оруулах",
    progressPrefix: "eshleluud-",
    total: 22,
  },
  {
    id: "duruud",
    to: "/duruud",
    icon: "columns",
    title: "3 дүр зөв байрлуулах",
    progressPrefix: "duruud-",
    total: 22,
  },
  {
    id: "buleg-taah",
    to: "/buleg-taah",
    icon: "image",
    title: "Зургаар бүлэг таах",
    progressPrefix: "buleg-taah-",
    total: 3,
  },
  {
    id: "tsag-uy",
    to: "/tsag-uy",
    icon: "clock",
    title: "Цаг үеүүд",
    progressPrefix: "tsag-uy-",
    total: 3,
  },
  {
    id: "bibleduruud",
    to: "/bibleduruud",
    icon: "people",
    title: "Библийн дүрүүд",
  },
  {
    id: "crosswords",
    to: "/crosswords",
    icon: "grid",
    title: "Үгийн сүлжээ",
    badge: "Шинэ",
  },
];

function CourseCard({ course, index, progress }) {
  const completed = course.progressPrefix
    ? Object.keys(progress).filter((key) =>
        key.startsWith(course.progressPrefix),
      ).length
    : 0;
  return (
    <Link to={course.to} className="course-card" aria-label={course.title}>
      <div className="course-card__top">
        <span className="course-card__icon">
          <Icon name={course.icon} size={27} />
        </span>
        <span className="course-card__type">
          {course.badge ? (
            <NewBadge label={course.badge} />
          ) : (
            String(index + 1).padStart(2, "0")
          )}
        </span>
      </div>
      <h3>{course.title}</h3>
      <div className="course-card__bottom">
        <span>
          {course.total
            ? completed
              ? `${completed} / ${course.total}`
              : ""
            : ""}
        </span>
        <span className="course-card__arrow">
          <Icon name="right" size={19} />
        </span>
      </div>
      {course.total && completed > 0 && (
        <div className="course-card__progress">
          <span
            style={{
              width: `${Math.min(100, (completed / course.total) * 100)}%`,
            }}
          />
        </div>
      )}
    </Link>
  );
}

export default function Homepage() {
  const progress = useProgress();
  return (
    <div className="home-page">
      <section className="home-hero">
        <div className="home-hero__copy">
          <span className="hero-tag">
            <Icon name="book" size={16} /> {APP_INFO.version}
          </span>
          <h1>МСС дасгал ажил</h1>
          <div className="home-hero__actions">
            <Link className="btn btn-light" to="/eshleluud">
              Эшлэлүүдийг зөв дараалалд оруулах <Icon name="right" size={19} />
            </Link>
            <Link className="btn btn-hero-outline" to="/bibleduruud">
              Библийн дүрүүд
            </Link>
          </div>
        </div>
        <div className="hero-art" aria-hidden="true">
          <div className="hero-art__halo" />
          <div className="hero-art__spark hero-art__spark--one">✦</div>
          <div className="hero-book hero-book--back" />
          <div className="hero-book hero-book--front">
            <span className="hero-book__cross">✝</span>
            <span className="hero-book__line" />
            <span className="hero-book__line hero-book__line--short" />
          </div>
        </div>
      </section>
      <section
        id="exercises"
        className="home-courses"
        aria-label="МСС дасгал ажил"
      >
        <div className="courses-grid">
          {courses.map((course, index) => (
            <CourseCard
              key={course.id}
              course={course}
              index={index}
              progress={progress}
            />
          ))}
        </div>
      </section>
    </div>
  );
}
